import { m } from 'framer-motion';
import { Link as RouterLink } from '@tanstack/react-router'
import { varBounce, MotionContainer, ACHelmetContainer } from '@emfood/shared';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { SeverErrorIllustration } from 'src/assets/illustrations';

// ----------------------------------------------------------------------

export default function Page500() {
  return (
    <ACHelmetContainer maxWidth="sm" title="Unexpected Issue">
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <MotionContainer>
          <m.div variants={varBounce().in}>
            <Typography variant="h3" sx={{ mb: 2 }}>
              Something Went Wrong
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography sx={{ color: 'text.secondary', mb: 4 }}>
              There was an error, please try again later.
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <SeverErrorIllustration
              sx={{
                height: 260,
                my: { xs: 5, sm: 10 },
                width: '100%',
                maxWidth: 400,
              }}
            />
          </m.div>

          <Button
            component={RouterLink}
            href="/"
            size="large"
            variant="contained"
            sx={{
              bgcolor: '#7A9A01', // primary.main
              color: '#FFFFFF', // primary.contrastText
              minWidth: 200,
              '&:hover': {
                bgcolor: '#516600', // primary.dark
              },
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.08)',
              borderRadius: 1,
              py: 1,
              px: 3,
            }}
          >
            Go to Home
          </Button>
        </MotionContainer>
      </Box>
    </ACHelmetContainer>
  );
}
